/* PrimeBuild Premium – página de producto.
   Aviso "Añadido al carrito" + contador del carrito de la cabecera PrimeBuild
   (la cabecera propia no tiene carrito lateral, así que antes no se veía nada al añadir). */
(function () {
  if (window.__pbpProductInit) return;
  window.__pbpProductInit = true;

  function cfg() {
    var el = document.querySelector('[data-pbp-cart-toast]');
    if (!el) return null;
    return {
      title: el.getAttribute('data-title') || 'Added to cart',
      view: el.getAttribute('data-view') || 'View cart',
      checkout: el.getAttribute('data-checkout') || 'Checkout',
      cartUrl: el.getAttribute('data-cart-url') || '/cart',
      checkoutUrl: el.getAttribute('data-checkout-url') || '/checkout'
    };
  }

  function updateHeaderCount(count) {
    if (typeof count !== 'number') return;
    document.querySelectorAll('a[aria-label="Cart"][class*="pb-icon-link-"]').forEach(function (link) {
      var badge = link.querySelector('[class*="pb-cart-count-"]');
      if (!badge && count > 0) {
        var m = (link.className.match(/pb-icon-link-([^\s]+)/) || [])[1];
        if (!m) return;
        badge = document.createElement('span');
        badge.className = 'pb-cart-count-' + m;
        link.appendChild(badge);
      }
      if (!badge) return;
      if (count > 0) { badge.textContent = count; badge.hidden = false; }
      else { badge.hidden = true; }
    });
  }

  var toast, timer;
  function showToast(c, info) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'pbp-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; };
    toast.innerHTML =
      '<span class="pbp-cart-toast__icon" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8.5l3.2 3L13 4.5"/></svg></span>' +
      '<span class="pbp-cart-toast__copy"><strong>' + esc(c.title) + '</strong>' +
        (info && info.name ? '<span class="pbp-cart-toast__name">' + esc(info.name) + '</span>' : '') +
        (info && info.variant ? '<span class="pbp-cart-toast__variant">' + esc(info.variant) + '</span>' : '') + '</span>' +
      '<span class="pbp-cart-toast__actions"><a class="pbp-cart-toast__view" href="' + esc(c.cartUrl) + '">' + esc(c.view) + '</a>' +
      '<a class="pbp-cart-toast__checkout" href="' + esc(c.checkoutUrl) + '">' + esc(c.checkout) + '</a></span>' +
      '<button type="button" class="pbp-cart-toast__close" aria-label="Close"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg></button>';
    toast.querySelector('.pbp-cart-toast__close').addEventListener('click', hide);
    // En ordenador, justo debajo de la cabecera (o arriba del todo si ya no se ve)
    if (window.innerWidth >= 750) {
      var hg = document.getElementById('header-group');
      var bottom = hg ? Math.max(0, hg.getBoundingClientRect().bottom) : 0;
      toast.style.top = Math.round(bottom + 12) + 'px';
    } else {
      toast.style.removeProperty('top');
    }
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(timer);
    timer = setTimeout(hide, 6500);
  }
  function hide() { if (toast) toast.classList.remove('is-visible'); }

  document.addEventListener('cart:update', function (e) {
    if (window.__pbpCartNotify) return; // 2026-10-13: ahora lo hace assets/pbp-cart-notify.js (mini carrito)
    var d = e && e.detail;
    if (!d || !d.data) return;
    var cart = d.resource;
    if (cart && typeof cart.item_count === 'number') updateHeaderCount(cart.item_count);
    if (d.data.source !== 'product-form-component' || d.data.didError) return;
    if (!document.querySelector('.pbp-pdp')) return;
    var c = cfg();
    if (!c) return;
    var info = null;
    if (cart && cart.items && d.sourceId) {
      var item = cart.items.find(function (i) { return String(i.variant_id) === String(d.sourceId) || String(i.id) === String(d.sourceId); });
      if (item) info = { name: item.product_title, variant: item.variant_title || '' };
    }
    showToast(c, info);
  });
})();
